import type { Middleware } from '@reduxjs/toolkit';
import { captureException } from '../utils/sentry/sentry-lazy';

export const sentryMiddleware: Middleware = (_store) => (next) => (action) => {
  try {
    return next(action);
  } catch (error) {
    captureException(error, {
      tags: { component: 'redux', actionType: (action as any)?.type || 'unknown' },
      extra: { action: shallowClone(action) },
    });
    throw error;
  }
};

function shallowClone<T>(obj: T): T {
  try {
    if (!obj || typeof obj !== 'object') return obj;
    const out: any = Array.isArray(obj) ? [...(obj as any)] : { ...(obj as any) };
    // Prevent very large payloads
    return JSON.parse(JSON.stringify(out, (_k, v) => v, 2).slice(0, 5000)) as T;
  } catch {
    return obj;
  }
}


